import apiSlice from "./apiSlice";

const costApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getCostProgressKpi: builder.query({
            query: (req) => ({
                url: `cost/progress-kpi`,
                params: req,
            }),
        }),
        getCostProgressCurve: builder.query({
            query: (req) => ({
                url: `cost/progress-curve`,
                params: req,
            }),
        }),
        getInvoiceDue: builder.query({
            query: (req) => ({
                url: `cost/invoice-due`,
                params: req,
            }),
        }),
        getPlanActual: builder.query({
            query: (req) => ({
                url: `cost/plan-actual`,
                params: req,
            }),
        }),
    }),
});

export const {
    useGetCostProgressKpiQuery,
    useGetCostProgressCurveQuery,
    useGetInvoiceDueQuery,
    useGetPlanActualQuery
} = costApiSlice;
